import type { AvatarField } from './avatar-catalog'
import type { AvatarIconName } from './AvatarIcon'

type Section = {
  id: string
  label: string
  title: string
  description: string
  icon: AvatarIconName
  fields: { field: AvatarField; label: string; colors?: boolean }[]
}

export const AVATAR_SECTIONS: Section[] = [
  {
    id: 'base',
    label: 'Rosto',
    title: 'Seu jeito começa aqui.',
    description: 'Escolha uma inspiração ou crie cada detalhe do zero.',
    icon: 'face',
    fields: [
      { field: 'skin', label: 'Tom de pele', colors: true },
      { field: 'face', label: 'Formato do rosto' },
      { field: 'body', label: 'Corpo' },
    ],
  },
  {
    id: 'hair',
    label: 'Cabelo',
    title: 'Um cabelo com personalidade.',
    description: 'Curto, longo, colorido. Encontre o seu estilo.',
    icon: 'hair',
    fields: [
      { field: 'hairColor', label: 'Cor do cabelo', colors: true },
      { field: 'hair', label: 'Penteado' },
      { field: 'facialHair', label: 'Barba e bigode' },
    ],
  },
  {
    id: 'eyes',
    label: 'Olhos',
    title: 'Um olhar que é só seu.',
    description: 'Combine o formato, a cor e as sobrancelhas.',
    icon: 'eye',
    fields: [
      { field: 'eyeColor', label: 'Cor dos olhos', colors: true },
      { field: 'eyes', label: 'Formato dos olhos' },
      { field: 'brows', label: 'Sobrancelhas' },
    ],
  },
  {
    id: 'expression',
    label: 'Expressão',
    title: 'Espalhe a sua energia.',
    description: 'Um sorriso e aqueles pequenos detalhes que fazem você.',
    icon: 'smile',
    fields: [
      { field: 'mouth', label: 'Boca' },
      { field: 'detail', label: 'Detalhes do rosto' },
    ],
  },
  {
    id: 'clothes',
    label: 'Roupas',
    title: 'Vista a sua personalidade.',
    description: 'Do básico ao extraordinário. Todas as peças são suas.',
    icon: 'shirt',
    fields: [
      { field: 'clothingColor', label: 'Cor da roupa', colors: true },
      { field: 'clothing', label: 'Roupa' },
    ],
  },
  {
    id: 'accessories',
    label: 'Acessórios',
    title: 'O toque final é seu.',
    description: 'Misture seus favoritos e deixe tudo com a sua cara.',
    icon: 'glasses',
    fields: [
      { field: 'accessory', label: 'Óculos' },
      { field: 'accessoryColor', label: 'Cor da armação', colors: true },
      { field: 'earrings', label: 'Brincos' },
      { field: 'headwear', label: 'Na cabeça' },
      { field: 'headwearColor', label: 'Cor do acessório', colors: true },
    ],
  },
  {
    id: 'background',
    label: 'Fundo',
    title: 'Uma cor para chamar de sua.',
    description: 'Escolha o cenário do seu novo perfil.',
    icon: 'palette',
    fields: [{ field: 'background', label: 'Cor de fundo', colors: true }],
  },
]
